import React from "react";
import { spring, interpolate, useCurrentFrame, useVideoConfig } from "remotion";
import { SvgIcon } from "../../components/SvgComponents";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
}

export const VelocityTechIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon = "terminal",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const iconEntrance = spring({
    frame: frame - 5,
    fps,
    config: { stiffness: 150, damping: 10 },
  });

  const textEntrance = spring({
    frame: frame - 15,
    fps,
    config: { stiffness: 100, damping: 12 },
  });

  const glowOpacity = interpolate(
    Math.sin(frame * 0.1),
    [-1, 1],
    [0.3, 0.8]
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "0 60px",
        gap: "40px",
        zIndex: 20,
      }}
    >
      {/* 1. Large Animated Hero SVG */}
      <div
        style={{
          opacity: iconEntrance,
          transform: `scale(${iconEntrance})`,
          filter: `drop-shadow(0 0 20px rgba(0, 212, 255, ${glowOpacity}))`,
        }}
      >
        <SvgIcon
          name={introIcon}
          width={360}
          height={360}
          primaryColor="#00d4ff"
        />
      </div>

      {/* 2. Headline Container */}
      <div style={{ textAlign: "center", width: "100%" }}>
        <h1
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "84px",
            fontWeight: 900,
            color: "white",
            margin: 0,
            lineHeight: 1.1,
            textTransform: "uppercase",
            letterSpacing: "-2px",
            opacity: textEntrance,
            transform: `translateY(${(1 - textEntrance) * 40}px)`,
          }}
        >
          {headline}
        </h1>

        {/* 3. Keywords Badges */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            marginTop: "24px",
            opacity: textEntrance,
            transform: `translateY(${(1 - textEntrance) * 20}px)`,
          }}
        >
          {keywords.map((kw, i) => (
            <span
              key={i}
              style={{
                background: "rgba(0, 212, 255, 0.1)",
                border: "1px solid rgba(0, 212, 255, 0.3)",
                color: "#00d4ff",
                padding: "8px 16px",
                borderRadius: "4px",
                fontFamily: "'Inter', sans-serif",
                fontSize: "20px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              {kw}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
